<div class="col-12">
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="card mb-3">
                    <div class="row">
                        <div class="col-md-12" style="margin-top: 1px; margin-left: 5px; margin-bottom: 5px;">
                            <b>¡BIENVENIDO!</b><br> <b>Estamos actualizando la base de datos de nuestros afiliados para garantizarte un óptimo acceso a tu cobertura.
                                Te agradecemos te tomes 5 minutos para completar el siguiente formulario, esta información es muy importante para mejorar nuestra comunicación y mantenerte plenamente actualizado.</b><br> <b>¡Muchas Gracias!</b>
                            <hr>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div style="margin-top: 20px; margin-left: 5px; ">
                                <label>1) Nombres: (*)</label>
                                <input type="text" class="form-control" name="afiNombreComp" placeholder="Nombres..." required [(ngModel)]="affiContrModel.afiNombre">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div style="margin-top: 20px;">
                                <label>2) Apellidos: (*)</label>
                                <input type="text" class="form-control" name="afiApellido" placeholder="Apellidos..." required [(ngModel)]="affiContrModel.afiApellido">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div style="margin-top: 20px; margin-left: 5px;">
                                <label>3) DNI: (*)</label>
                                <input type="text" mask="0*" maxlength="8" class="form-control" name="afiDni" placeholder="DNI..." required [(ngModel)]="affiContrModel.afiDni">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div style="margin-top: 20px;">
                                <label>4) Teléfono: (*)</label>
                                <input type="text" mask="0*" maxlength="10" class="form-control" name="afiTelef" placeholder="TEL: sin 0 y 15 (ej: 3512345679)" required [(ngModel)]="affiContrModel.afiTelef">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">

                            <div style="margin-top: 25px; margin-left: 5px;">
                                <div style="margin-bottom: 5px;">
                                    <label class="lblDireccion">5) Dirección: (*)</label>
                                </div>
                                <div class="input-group">
                                    <input #searchGMaps id="searchfield" name="searchfield" type="search" class="form-control" placeholder="Buscar Direccion Google-MAPs" autocomplete="google" onkeypress="return event.keyCode != 13;" required [(ngModel)]="affiContrModel.afiDireccion" />
                                    <button style="margin-left: 5px ;" type="button" class="btn btn-primary btn-sm btn-rounded" alt="Ver Mapa" title="Ver Mapa" (click)="verMapa()"><i class="fa fa-map-marker"></i>&nbsp;{{tituloBoton}} </button>&nbsp;&nbsp;
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div style="margin-top: 20px;">
                                &nbsp;
                            </div>
                        </div>
                    </div>
                    <div class="row" [ngStyle]="!mostrarMapa ? {'visibility': 'hidden', 'height': '1px'} : {'visibility': 'visible', 'height': '350px'}">
                        <div class="col-md-12">
                            <style>
                                #map {
                                    /*width: 100%;*/
                                    height: 300px;
                                    margin-left: 50px;
                                    margin-right: 50px;
                                    margin-bottom: 20px;
                                    margin-top: 0px;
                                }
                            </style>

                            <div id="map">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div style="margin-top: 20px; margin-left: 5px;">
                                <label>6) Referencias:</label>
                                <div class="input-group">
                                    <textarea class="form-control" rows="2" cols="50" name="afiReferencias" [(ngModel)]="affiContrModel.afiReferencias" placeholder="(Por ej: CASA VERDE, REJAS NEGRAS, MANZANA 12)"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div style="margin-top: 20px;">
                                <label>7) Mail: (*)</label>
                                <input type="email" class="form-control" name="afiMail" placeholder="ejemplo@gmail.com" [(ngModel)]="affiContrModel.afiMail">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div style="margin-top: 0px; margin-left: 5px;">
                                &nbsp;
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div style="margin-top: 20px;">
                                <label>8) {{labelPregunta8}}</label>

                                <!-- Este combo se usa para el modelo 3 -->
                                <div *ngIf="mostrarParentezcoMod3" style="margin-top: 20px; ">
                                    <label>Parentesco:</label>
                                    <select class="form-control custom-select" placeholder="Escoge una Opcion" name="parentezcoPreg8" [(ngModel)]="valorParentezco" (change)="mostrarCampos()">
                                          <option value="MADRE">MADRE</option>
                                          <option value="PADRE">PADRE</option>
                                          <option value="TUTOR">TUTOR</option>
                                          <option value="OTRO">OTRO</option>
                                      </select>
                                </div>

                                <!-- Este campo parentesco se usa para el modelo 1 -->
                                <div *ngIf="mostrarParentezco" style="margin-top: 20px; ">
                                    <label>Parentesco:</label>
                                    <input type="text" class="form-control" name="parentezcoPreg8" placeholder="Parentesco..." [(ngModel)]="valorParentezcoOtro" (ngModelChange)="mostrarCampos()">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div style="margin-top: 0px;">
                                &nbsp;
                            </div>
                        </div>
                    </div>
                    <!-- Aqui empieza el contacto para modelo 2 -->
                    <div class="row" *ngIf="verCamposConyugue">
                        <div class="col-md-6" style="margin-top: 5px;">
                            <label>Teléfono de contacto: </label>
                            <input type="text" mask="0*" maxlength="10" class="form-control" name="telefonoPreg8" placeholder="TEL: sin 0 y 15 (ej: 3512345679)" [(ngModel)]="valorTelefono">
                        </div>
                        <div class="col-md-6">
                            <div style="margin-top: 0px;">
                                &nbsp;
                            </div>
                        </div>

                    </div>

                    <div class="row" *ngIf="verCamposConyugue">
                        <div class="col-md-6">
                            <div style="margin-top: 10px;">
                                <label>Mail de contacto:</label>
                                <input type="text" class="form-control" name="mailPreg8" placeholder="ejemplo@gmail.com" [(ngModel)]="valorMail">
                            </div>
                        </div>
                    </div>



                    <!-- Aqui empieza el contacto para modelo 1 y 3 -->
                    <div class="row">
                        <div class="col-md-6" style="margin-top: 5px;" *ngIf="verCampoOtro">
                            <label>Especifique el parentesco: </label>
                            <input type="text" class="form-control" name="parentezcoPreg8" placeholder="Parentesco..." [(ngModel)]="valorParentezcoOtro">
                        </div>
                        <div class=" col-md-6">
                            <div style="margin-top: 0px;">
                                &nbsp;
                            </div>
                        </div>
                    </div>



                    <div class="row" [ngStyle]="!verCampos ? {'visibility': 'hidden'} : {'visibility': 'visible'}">
                        <div class="col-md-6" style="margin-top: 5px;">
                            <label>Teléfono de contacto: </label>
                            <input type="text" mask="0*" maxlength="10" class="form-control" name="telefonoPreg8" placeholder="TEL: sin 0 y 15 (ej: 3512345679)" [(ngModel)]="valorTelefono">
                        </div>
                        <div class=" col-md-6">
                            <div style="margin-top: 0px;">
                                &nbsp;
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div style="margin-top: 10px;">
                                <label>Mail de contacto:</label>
                                <input type="text" class="form-control" name="mailPreg8" placeholder="ejemplo@gmail.com" [(ngModel)]="valorMail">
                            </div>

                        </div>
                    </div>

                </div>
                <div class="card-body">
                    <div style="margin-left: 70%; margin-top: 80px; margin-right: 5px">
                        <button (click)="saveAffiliateDates()" class="btn btn-info btn-rounded">Finalizar &nbsp; </button>
                    </div>
                </div>
            </div>
        </div>
        <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
            <p style="color: white">Cargando... espere por favor </p>
        </ngx-spinner>